
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import {
  getAccountGroupListInfo,
  editAccountGroupList
} from '@/api/product/accountGroup'
import {
  newProductAccount,
  getProductAccountList
} from '@/api/product/productAccount'
import { accountGroupRules } from '@/utils/rules'
import { Form as ElForm } from 'element-ui'
import { delObjEmptyKey } from '@/utils'
import { getType } from '@/utils/cookies'

@Component({
  name: 'editAccountGroup',
  components: {}
})
export default class extends Vue {
  @Prop({ default: [] }) accountGroupId!: string
  @Prop({ required: true }) product!: any

  private infoForm: any = {
    product_account: [],
    name: '',
    product: null,
    status: null
  }
  private isLoad: boolean = true
  private page: number = 1
  private page_size: number = 50
  private productAccountList: any[] = []
  private listInfo: any = {}
  private status: any = null
  private loading = false
  private rules = accountGroupRules
  private accountLoading: boolean = false
  private sysType: any = ''

  private currentSelection: any = []
  private reqArr: any = []
  // 获取产品账户数组中相同的
  private clickAccount(e: any) {
    this.currentSelection = this.productAccountList.filter((item: any) => {
      if (e.indexOf(item.id) !== -1) {
        if (!item.weight) {
          item.weight = ''
        }
        if (item.weight && item.weight.weight) {
          item.weight = item.weight.weight
        }
        return item
        // return item
      }
    })
  }
  // 获取产品账户数组中相同的
  private clickAntAccount(e: any) {
    this.currentSelection = this.productAccountList.filter((item: any) => {
      if (e.indexOf(item.id) !== -1) {
        return item
      }
    })
  }
  private arr: any = []
  private antAccountList: any = []
  private async remoteMethod(query) {
    if (query !== '') {
      const data: any = {
        product: this.infoForm.product,
        name: query,
        type: this.type
      }
      await getProductAccountList(data).then((res: any) => {
        this.antAccountList = res.results.filter(
          item => !this.historyList.some(item2 => item2.id === item.id)
        )
      })
    }
  }
  private changeArr(val) {
    let indexLen: number = val.length
    val.forEach((item, index, arr) => {
      let itemArr: any = item.split(',')
      let obj: any = {}
      obj.id = itemArr[0] - 0
      obj.account_name = itemArr[1]
      obj.state = itemArr[2] - 0
      obj.weight = itemArr[3] - 0
      obj.account_type = itemArr[4]
      if (indexLen - 1 === index) {
        this.productAccountList.push(obj)
      }
    })
    const map = new Map()
    this.productAccountList = this.productAccountList.filter(
      v => !map.has(v.id) && map.set(v.id, 1)
    )
  }
  private itemArr: any = []
  private removeArr(val) {
    this.itemArr = val.split(',')
    this.productAccountList = this.productAccountList.filter(item => {
      return item.id !== this.itemArr[0] - 0
    })
  }

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private back() {
    this.$emit('close')
  }

  private async save() {
    ;(this.$refs.infoForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          // 处理产品账户选择之后的轮询权重数组
          this.reqArr = this.currentSelection.map((item: any) => {
            return {
              id: item.id,
              weight: Number(item.weight)
            }
          })
          this.infoForm.product_account = this.reqArr.map(
            (item: any) => item.id
          )
          this.loading = true
          this.flag = true
          const data = {
            ...this.infoForm,
            id: this.accountGroupId,
            weight: this.reqArr
          }
          delObjEmptyKey(data)
          await editAccountGroupList(data).then(() => {
            this.$message({
              message: 'Edit Successful!',
              type: 'success'
            })
            this.loading = false
            this.flagStr()
            this.back()
          })
        } catch (e) {
          this.loading = false
          this.flagStr()
        }
      } else {
        return false
      }
    })
  }

  // 获取账户组详情
  private historyList: any = []
  private async getAccountGroupListInfo() {
    const data = {
      id: this.accountGroupId
    }
    await getAccountGroupListInfo(data).then((res: any) => {
      this.listInfo = res
      this.infoForm.product_account = res.product_account
      this.infoForm.name = res.name
      this.productAccountList = res.group_product_account
      this.historyList = res.group_product_account
      if (this.sysType !== 'ant') {
        this.getAccountList('normal')
      } else {
        if (this.type === 'normal') {
          this.getAccountList('normal')
        } else {
          this.productAccountList = []
        }
      }
      this.currentSelection = res.group_product_account.filter((item: any) => {
        if (this.infoForm.product_account.indexOf(item.id) > -1) {
          return item
        }
      })
    })
  }

  // 产品账户列表的重复ID优化
  @Watch('infoForm.product_account')
  private onProductAccount(e: any) {
    return Array.from(new Set(this.productAccountList))
  }

  // 监听当前创建的产品
  @Watch('product.name', { immediate: true })
  private productChange() {
    this.infoForm.product_name = this.product.name
    this.infoForm.product = this.product.id
    this.infoForm.product_account = []
    this.page = 1
    this.isLoad = true
    this.productAccountList = []
  }

  // 获取产品账户列表
  private async getAccountList(type: string) {
    this.accountLoading = true
    if (type === 'ant') {
      const data: any = {
        product: this.infoForm.product,
        account_group: this.accountGroupId,
        type: type
      }
      await newProductAccount(data).then((res: any) => {
        const list: any[] = res
        this.productAccountList = res
        this.accountLoading = false
        if (list.length !== 0) {
          let listOne = res.filter(
            item => !this.historyList.some(item2 => item2.id === item.id)
          )
          this.productAccountList = [...this.historyList, ...listOne]
          this.currentSelection = this.productAccountList.filter(
            (item: any) => {
              if (this.infoForm.product_account.indexOf(item.id) > -1) {
                return item
              }
            }
          )
          if (list.length < 50) {
            this.isLoad = false
          } else {
            this.page++
          }
        } else {
          this.productAccountList = this.historyList
        }
      })
    } else {
      const data: any = {
        product: this.infoForm.product,
        group: this.accountGroupId,
        type: type
      }
      await newProductAccount(data).then((res: any) => {
        const list: any[] = res
        this.productAccountList = res
        this.accountLoading = false
        if (list.length !== 0) {
          let listOne = res.filter(
            item => !this.historyList.some(item2 => item2.id === item.id)
          )
          this.productAccountList = [...this.historyList, ...listOne]
          this.currentSelection = this.productAccountList.filter(
            (item: any) => {
              if (this.infoForm.product_account.indexOf(item.id) > -1) {
                return item
              }
            }
          )
          if (list.length < 50) {
            this.isLoad = false
          } else {
            this.page++
          }
        } else {
          this.productAccountList = this.historyList
        }
      })
    }
  }

  private changeInput() {
    this.$forceUpdate()
  }

  private type: string = 'normal'
  private selProductType(val: any) {
    if (val === 'ant') {
      this.getAccountList('ant')
    } else if (val === 'normal') {
      this.getAccountList('normal')
    }
  }

  mounted() {
    this.sysType = getType()
    this.getAccountGroupListInfo()
  }
}
